/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tos-page[_ngcontent-%COMP%]{\n  margin: 10px 25px 10px 25px;\n  background-color: #ffffff;\n  border: 1px solid #c9c7c7;\n  padding: 25px;\n}\n.tos-page[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{\n  padding: 10px;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/terms-of-service/terms-of-service.component.css.shim.ngstyle.js.pre-build-optimizer.js